<template>
  <div>
    <el-card>
      <el-alert type="error" :closable="false" class="mb-2">
        <template #title>
          <strong>
            {{ dt(promotion.title_translations) }}
          </strong>
        </template>
      </el-alert>
      <RatioImage
        v-if="promotion.banner_media"
        ratio="1:1"
        :src="imgProxy(promotion.banner_media?.url)"
        :tip="dt(promotion.title_translations)"
      />
      <div class="mt-1 d-flex justify-content-between">
        <div class="d-flex">
          <el-tag type="danger" effect="dark" class="mr-1">{{ promotionTypeLabel }}</el-tag>
  
          <div v-for="condition in promotion.conditions">
            {{ t("promotions.bundle") }} 
            <span class="text-primary">{{ condition.min_qty }}</span>
            {{ t("promotions.fillUnit") }}, 
  
            <span v-if="promotion.discount_type == 'amount'">
              {{ t("promotions.discounts") }}
              {{ condition.discount_amount }}
            </span>
            <span v-else-if="promotion.discount_type == 'percentage'">
              {{ t("promotions.discounts") }}
              {{ condition.discount_percentage }} %
            </span>
            <span v-else-if="promotion.discount_type == 'gift'">
              {{ t("promotions.freeGift") }}
            </span>
            <span v-else-if="promotion.discount_type == 'pricing'">
              共 $
              <span class="text-primary">{{ condition.discounted_price }}</span>
              元
            </span>
            <div>
              <el-popover
                :placement="isMobile ? 'bottom' : 'right'"
                title="活動資訊"
                trigger="hover"
                :width="isMobile ? 350 : 450"
              >
                <template #reference>
                  <el-button type="text">
                    更多活動資訊, 請查閱
                    <el-icon class="el-icon--right"><ArrowRight /></el-icon>
                  </el-button>
                </template>
                
                <div class="w-100 d-flex flex-wrap my-2">
                  <div class="w-auto text-muted mr-2">活動時間</div>
                  <div class="w-75">
                    <date-countdown
                      v-if="promotion.ended_at || isComing"
                      :start-date="promotion.start_at"
                      :end-date="promotion.ended_at"
                      label="promotions.countdownCloseSingle"
                    />
                    <div v-else>
                      {{ dateFormat(promotion.start_at, format) }}
                    </div>
                  </div>
                </div>

                <div v-if="term_translations" class="w-100 d-flex flex-wrap my-2">
                  <div class="w-auto text-muted mr-2">活動細則</div>
                  <div class="w-75">
                    {{ term_translations }}
                  </div>
                </div>

                <div class="w-100 d-flex flex-wrap my-2">
                  <div class="w-auto text-muted mr-2">付款方式</div>
                  <div class="w-75">
                    {{ whitelistedPaymentNames.join(" | ") }}
                  </div>
                </div>

                <div class="w-100 d-flex flex-wrap my-2">
                  <div class="w-auto text-muted mr-2">配送方式</div>
                  <div class="w-75">
                    {{ whitelistedLogisticNames.join(" | ") }}
                  </div>
                </div>

                <div class="w-100 d-flex flex-wrap my-2">
                  <div class="w-auto text-muted mr-2">免運規則</div>
                  <div class="w-75">
                    <span v-if="promotion.min_amount_free_shipping">
                      滿 {{ currencyFormat(promotion.min_amount_free_shipping) }} 免運 
                      <span v-if="promotion.is_excluded_outer_island_free_shipping">(外島不適用)</span>
                    </span>
                    <span v-else>無</span>
                  </div>
                </div>
                <div v-if="promotion.supplier_name" class="w-100 d-flex flex-wrap my-2">
                  <div class="w-auto text-muted mr-2">出貨廠商</div>
                  <span>{{ promotion.supplier_name }}</span>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
        <div v-if="!hiddenCart">
          已選購
          <span class="text-primary">{{ $n(cartCount) }}</span>
          {{ t("promotions.fillUnit") }}

          <el-button 
            v-if="cartCount > 0" 
            type="primary" 
            :disabled="!cartCount || checkAddon" 
            :loading="loadingForm"
            @click="handleOpenCheckoutDialog"
            >
            {{ aliasTranslations?.checkout || $t("carts.checkout") }}
          </el-button>
        </div>
      </div>
    </el-card>

    <el-card v-if="!hiddenCart" v-loading="loadingForm" class="my-2">
      <el-alert type="info" effect="dark" :closable="false" class="mb-2">
        <template #title>
          <strong style="font-size: large;">
            已選購商品
          </strong>
        </template>
      </el-alert>
      <el-scrollbar v-if="cartCount">
        <div class="scrollbar-flex-content">
          <div v-for="(item, idx) in promoCarts" :key="idx" class="scrollbar-cart-item">
            <el-card size="small" class="w-100 h-100" :body-style="{ padding: '8px', height: '100%' }">
              <RatioImage
                v-if="item?.image_url"
                ratio="1:1"
                :src="imgProxy(item?.image_url)"
                :tip="item.product_name"
              />
              <div class="d-flex flex-column align-items-end mt-2" style="height: 150px;">
                <div class="w-100 text-left text-truncate-2">{{ item.product_name }}</div>
                <div class="w-100 text-left text-truncate-2">{{ item.assort_name }}</div>
                <div class="mt-auto d-flex justify-content-between align-items-center w-100">
                  <div>數量: {{ $n(item.quantity) }}</div>
                  <el-button type="danger" :icon="Delete" circle text @click="deleteCartWithConfirm(item)" />
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </el-scrollbar>
      <EmptyCartImage v-else />
      
    </el-card>

    <div class="d-flex justify-content-center align-items-center mb-3" style="min-height: 70px;background:#3b71de10;width:100%;">
      <div class="row text-capitalize">
        <span style="font-weight: 600;font-size: 18px;">活動商品</span>
      </div>
    </div>
    <div class="pb-5 mb-2 mb-md-4 rtl" style="text-align: left;">
      <div class="row mt-3" :class="buyNow ? 'alerts-border rounded' : ''">
        <promotion-product-item
          v-for="item in promotion.whitelisted_store_products"
          :key="item.id"
          :item="item"
          :is-coming="isComing"
          :is-ended="isEnded"
          :display-coin-reward="promotion.display_coin_reward"
          :is_login="is_login"
          :is-distribute="isDistribute"
          :target="target"
          :store-data="storeData"
          @show="handleShowItem"
          @show-coin="showCoinLevel"
          @view="handleQuickView"
          @quick-add="handleQuickAddToCart"
        />
      </div>
    </div>

    <!--活動贈品 -->
    <PromotionGiftCard v-if="promotion.discount_type == 'gift'" :promotion="promotion" />

    <!-- 查看規格 -->
    <ProductAssortSelectModal
      :data="modalState"
      :loading="loadingForm"
      :store-data="storeData"
      @add-to-cart="addToCartByAssort"
      @buy-now="buyNowByAssort"
    />
    <!-- 商品詳情 -->
    <promotion-product-quick-view
      v-if="dialogVisible"
      v-model="dialogVisible"
      :product="modalState.item"
      :is-distribute="isDistribute"
      :target="target"
      :assort-detail="assortDetail"
      @show="handleShowItem"
    />
    <!-- 佣金詳情 -->
    <promotion-coin-detail
      v-if="levelState.visible"
      v-model="levelState.visible"
      :product="levelState.item"
      :levels="distributorLevels"
      :distributor="distributor"
    />

    <!-- 快速加入購物車 -->
    <promotion-product-quick-add
      v-model="prodState.visible"
      :data="promotion?.whitelisted_store_products"
      @ok="handleQuickAddToCart"
    />

    <!-- 手機版置底條 -->
    <div class="d-md-none fixed-bottom" style="background-color: #eaeaea; height: 74px; border-top: 1px solid #eee;">
      <promotion-title-block
        :promotion="promotion"
        :is_login="is_login"
        :store-data="storeData"
        button-only
        @buy-now="clickQuickAddToCart(true)"
        @add-to-cart="clickQuickAddToCart(false)"
        @msg="redirectToFBMSN"
      />
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from 'vue'
import { useI18n } from "vue-i18n"
import { useStore } from 'vuex'
import { cloneDeep } from "lodash"
import { _api_createCartGroup, _api_getProduct,  _api_deleteCart } from "../api/index.js";
import {
  breakpoint,
  parseVideoTag,
  redirectFBMSN,
  getAssorts,
  addToCartSuccess,
  checkBuyQty,
  lookupPromotionTypes,
} from "../utils"
import { dataTranslations as dt, notificationErrors, currencyFormat, checkValidCurrencyStr, dateFormat, assignCartCount, imgProxy, lookupAliasTranslations } from "../utils"
import PromotionTitleBlock from "./promotions/PromotionTitleBlock.vue"
import PromotionProductItem from "./promotions/PromotionProductItem2.vue"
import PromotionProductQuickView from "./promotions/PromotionProductQuickView.vue"
import PromotionProductQuickAdd from "./promotions/PromotionProductQuickAdd.vue"
import PromotionCoinDetail from "./promotions/PromotionCoinDetail.vue"
import PromotionGiftCard from "./promotions/PromotionGiftCard.vue"
import ProductAssortSelectModal from './products/ProductAssortSelectModal.vue'
import EmptyCartImage from "./EmptyCartImage.vue";
import RatioImage from './RatioImage.vue'
import DateCountdown from "./promotions/DateCountdown.vue"
import { ElLoading } from 'element-plus'
import { ArrowRight, Delete } from '@element-plus/icons-vue'

const props = defineProps({
  promotion: Object,
  distributor: Object,
  distributorLevels: Array,
  storeData: Object,
  is_login: { type: Boolean, default: false },
  userData: Object,
})

const { t, n, locale } = useI18n()
const store = useStore()

const format = "YYYY/MM/DD HH:mm a"

const hiddenPrice = computed(() => !!props.storeData?.settings?.hidden_price)
const hiddenCart = computed(() => !!props.storeData?.settings?.hidden_cart)
const hiddenContact = computed(() => !!props.storeData?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(props.storeData?.alias_translations, locale.value))

const cartData = computed(() => store.getters['lite/cartData'])
const promoCarts = computed(() => {
  if (!!cartData.value?.carts) {
    return cartData.value.carts.filter((el) => el?.event_group?.event_id === props.promotion?.id)
  }
  return []
})
const cartCount = computed(() => {
  let cnt = 0
  if (promoCarts.value.length) {
    promoCarts.value.forEach((cart) => {
      cnt += cart.quantity
    })
  }
  return cnt
})

const isMobile = computed(() => breakpoint.value.xs)

const storeId = computed(() => props.storeData?.follow_store_id || props.storeData?.id)
const refStoreId = computed(() => props.storeData?.id)
const logistics = computed(() => props.storeData?.logistics || [])
const payments = computed(() => props.storeData?.payments || [])

const isDistribute = computed(() => !!props.distributor?.id)
const target = computed(() => props.promotion.target)
const description_translations = computed(() => {
    if (Object.keys(props.promotion.description_translations).length) {
        let desc = dt(props.promotion.description_translations)
        // console.log("desc: ", desc)
        return parseVideoTag(desc)
    }
    return null
})
const term_translations = computed(() => {
    if (Object.keys(props.promotion.term_translations).length) {
        let term = dt(props.promotion.term_translations)
        return term
    }
    return null
})
const isComing = computed(() => props.promotion.start_at ? dayjs(props.promotion.start_at) > dayjs() : false)
const isEnded = computed(() => props.promotion.ended_at ? dayjs(props.promotion.ended_at) < dayjs() : false)

const whitelistedPaymentNames = computed(() => {
  let whitelisted_payment_names = []
  payments.value.forEach((payment) => {
    // if (props.promotion.whitelisted_payment_types.includes(payment.type)) {
      whitelisted_payment_names.push(dt(payment.name_translations))
    // }
  })
  return whitelisted_payment_names
})
const whitelistedLogisticNames = computed(() => {
  let whitelisted_logistic_names = []
  logistics.value.forEach((logistic) => {
    // if (props.promotion.whitelisted_delivery_types.includes(logistic.delivery_type)) {
      whitelisted_logistic_names.push(dt(logistic.name_translations))
    // }
  })
  return whitelisted_logistic_names
})
const promotionTypeLabel = computed(() => {
  const list = lookupPromotionTypes()
  const item = list.find((el) => el.value === props.promotion?.type)
  if (item) {
    return item.label
  }
  return props.promotion?.type
})

const modalState = reactive({
    title: "",
    item: null,
    visible: false,
})
const buyNow = ref(false)
const loadingForm = ref(false)
const dialogVisible = ref(false)

const prodState = reactive({
  visible: false,
  redirect: false,
})

const clickQuickAddToCart = (redirect = false) => {
  // console.debug("clickQuickAddToCart", props.promotion)
  if (!props.promotion?.whitelisted_store_products || !props.promotion?.whitelisted_store_products.length) {
    return handleBuyNow()
  }
  prodState.redirect = redirect
  if (props.promotion?.whitelisted_store_products.length === 1) {
    handleQuickAddToCart(props.promotion?.whitelisted_store_products[0])
  } else {
    prodState.visible = true
  }
}

const redirectToFBMSN = (store_product_id = null) => {
  // console.debug("redirectToFBMSN", props.storeData)
  if (!props.storeData?.fbmsn_base_url) {
    swal.fire({
      title: '查無可用粉絲團資訊',
      type: 'error',
    })
    return
  }
  return redirectFBMSN(
    props.storeData.fbmsn_base_url,
    "/promotion",
    storeId.value,
    refStoreId.value,
    props.promotion.id,
    store_product_id
  )
}

const handleCloseItem = () => {
  modalState.visible = false
}

const handleShowItem = (item) => {
  // console.log("handleShowItem: ", item);
  modalState.title = dt(item.name_translations);
  modalState.item = item;
  modalState.item.assorts = getAssorts(item);
  modalState.visible = true
}

const levelState = reactive({
  item: null,
  visible: false,
})
const showCoinLevel = (item) => {
  // 佣金詳情
  levelState.item = item
  levelState.visible = true
}

const assortDetail = ref(true)
const handleQuickView = (item, select_assort_btn = true) => {
  assortDetail.value = select_assort_btn
  modalState.title = dt(item.name_translations);
  modalState.item = item;
  dialogVisible.value = true
}

const setPayload = (items) => {
  return {
    event_id: props.promotion.id,
    event_name: dt(props.promotion.title_translations),
    event_type: props.promotion.type,
    items: items,
  };
}

const buyNowByAssort = (items) => {
  loadingForm.value = true
  addToCartByPayload(setPayload(items), true)
}
const addToCartByAssort = (items) => {
  loadingForm.value = true
  addToCartByPayload(setPayload(items), false)
}

const handleQuickAddToCart = async (item) => {
  window.ElFullPageLoading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.5)',
  });
  try {
    if (!item?.assorts || !item?.assorts.length) {
      swal.fire({
        title: '查無商品可用規格',
        type: 'error',
      });
      window.ElFullPageLoading && window.ElFullPageLoading.close();
      return;
    }
    const assort = item?.assorts[0]

    // window.fullPageLoading("show")
    loadingForm.value = true

    const payload = {
      event_id: props.promotion.id,
      event_name: dt(props.promotion.title_translations),
      event_type: props.promotion.type,
      items: [{
        store_product_id: item?.id,
        store_assort_id: assort?.id,
        quantity: 1,
        prod_name: dt(item?.name_translations),
        prod_assort_name: dt(assort?.name_translations),
        price: assort?.discounted_price || assort?.sale_price,
      }],
    };
    // console.log("handleQuickAddToCart", payload);

    addToCartByPayload(payload, prodState.redirect)

  } catch (error) {
    // console.error("handleQuickAddToCart fais", error)
    window.ElFullPageLoading && window.ElFullPageLoading.close();
    notificationErrors(error)
  } finally {
    // window.fullPageLoading("hide")
    loadingForm.value = false
  }
}

const addToCartByPayload = (payload, redirect = false) => {
  window.ElFullPageLoading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.5)',
  });
  let is_success = false
  _api_createCartGroup(payload)
    .then((data) => {
      // console.log("addToCart success: ", data?.headers);
      localStorage.removeItem('ADD_TO_CART_GROUP')
      handleCloseItem()
      assignCartCount(true)
      addToCartSuccess()
      const eventID = data?.headers?.["x-request-id"] ? data?.headers?.["x-request-id"] : null
      aibTrackers.addToCart(payload, null, eventID)
      gtmTrackers.addToCart(payload, null, eventID)
      fbqTrackers.addToCart(payload, null, eventID)
      ttqTrackers.addToCart(payload, null, eventID)
      gtagTrackers.addToCart(payload, null, eventID)
      lineAdsTrackers.createEvent('AddToCart', {}, eventID)
      is_success = true
    })
    .catch((err) => {
      if (err?.errors) {
        const { type, msg } = err.errors[0]
        if (type == "RequireLoginError") {
          const temp = {"payload": payload, "redirect": redirect}
          localStorage.setItem('ADD_TO_CART_GROUP', JSON.stringify(temp))
        } else {
          localStorage.removeItem('ADD_TO_CART_GROUP')
        }
      }
      notificationErrors(err)
    })
    .finally(() => {
      window.ElFullPageLoading && window.ElFullPageLoading.close();
      // window.fullPageLoading("hide")
      loadingForm.value = false

      if (is_success) {
        if (redirect && !!props.storeData?.fbmsn_base_url) {
          return redirectFBMSN(
            props.storeData.fbmsn_base_url,
            "/buy_now",
            storeId.value,
            refStoreId.value,
            props.promotion.id,
          )
        } else {
          updateCart()
          // $("#shopping-cart-drawer").click();
        }
      }
    })
}

const updateCartCount = () => {
  _api_getCarts()
    .then((res) => {
      const newCartCount = res?.count || 0;
      store.commit('lite/setCartCount', newCartCount);
    });
}

const updateCart = () => {
  store.dispatch('lite/updateCart');
}

const deleteCartWithConfirm = (cart) => {
  swal
    .fire({
      title: "確認從購物車移除？",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: "#dd3333",
      cancelButtonColor: "#78909C",
      confirmButtonText: "確認移除",
      cancelButtonText: "按錯了!",
    })
    .then(async (result) => {
      if (result.value === true) {
        const loading = ElLoading.service({
          lock: true,
          background: 'rgba(0, 0, 0, 0.5)',
        });
        try {
          const res = await _api_deleteCart(cart.cart_id)
          const eventID = res?.headers?.["x-request-id"] ? res?.headers?.["x-request-id"] : null
          aibTrackers.removeFromCart(cart, eventID)
          gtmTrackers.removeFromCart(cart, eventID)
          fbqTrackers.removeFromCart(cart, eventID)
          ttqTrackers.removeFromCart(cart, eventID)
          gtagTrackers.removeFromCart(cart, eventID)
          cartData.value.carts = cartData.value.carts.filter((el) => el.cart_id !== cart.cart_id)
          updateCartCount()
          // console.debug("deleteCart: ", cart)
        } catch (error) {
          notificationErrors(error);
        } finally {
          loading.close();
        }
      }
    });
}

const checkAddon = computed(() => {
  const disabled = false
  if (promoCarts.value === undefined || !promoCarts.value.length) {
    return disabled
  }
  const hasAddon = promoCarts.value.findIndex((el) => el.ptype === "SADDT")
  const hasProd = promoCarts.value.findIndex((el) => el.ptype === "SPROD")
  // console.debug("hasAddon: ", hasAddon)
  // console.debug("hasProd: ", hasProd)
  if (hasAddon !== -1 && hasProd === -1) {
    return true
  }

  return disabled
})

const handleGoUrl = (url) => {
  loadingForm.value = true
  window.location.href = url
}

const initData = async () => {
  window.ElFullPageLoading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.5)',
  });
  await store.commit('lite/setStoreData', props.storeData);
  await store.commit('lite/setDealerData', props.dealerData);
  await store.commit('lite/setIsSubscribe', props.isSubscribe);
  // 特殊處理 user.mobile E164 to local number
  const userData = cloneDeep(props.userData);
  // if (userData?.mobile && userData?.mobile?.startsWith("+")) {
  //     const phoneNumber = parsePhoneNumber(userData.mobile);
  //     if (['TW', 'MY'].includes(phoneNumber.country)) {
  //         userData.mobile = `0${phoneNumber.nationalNumber}`
  //     } else {
  //         userData.mobile = `${phoneNumber.nationalNumber}`
  //     }
  // }
  await store.commit('lite/setUserData', userData);
  await updateCart();
  window.ElFullPageLoading && window.ElFullPageLoading.close();
  console.debug('initData', userData)
}

const handleOpenCheckoutDialog = () => {
  store.dispatch('lite/openCheckoutDialog');
}

onMounted(() => {
  initData()
})
</script>

<style lang="scss">
.el-alert__content {
  padding-top: 8px;

  .el-alert__title {
    font-size: large;
    line-height: 22px;
  }
}
.scrollbar-flex-content {
  display: flex;
}
.scrollbar-cart-item {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 350px;
  margin: 10px;
  text-align: center;
  border-radius: 4px;
}
</style>
